import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faGreaterThan, faLessThan, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { API_URL, myHistory } from "./index";
import { MarkdownPreview } from './MarkdownPreview';
import { Avatar } from "./Avatar";

const MonthDiv = styled.div`
  margin-bottom: .5em;
  margin-left: 10px;

  text-transform: uppercase;

  color: rgba(51, 51, 51, 0.7);

  font-family: Lato, sans-serif;

  font-size: 10px;

  font-weight: bold;

  letter-spacing: 1px;

  line-height: 12px;

  padding-top: 24px;

`;
const EventDiv = styled.div`
  min-height: 38px;

  margin-top: 1em;

  width: 100%;

  :hover {
    cursor: pointer;
  }
`;

const EventDiv2 = styled.div`



  //@media only screen and (min-width: 1279px) {
  //
  // }
  margin-left: 10px;

  margin-right: 10px;

  display: flex;

  border-radius: 4px;

  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 7px 0px;

  min-height: 38px;

  margin-bottom: 8px;

  box-sizing: border-box;

  padding: 0.25em .5em;

  overflow: hidden;

  word-break: break-word;

  overflow-wrap: break-word;

  -moz-box-align: center;

  flex-direction: column;

  -moz-box-pack: justify;

  justify-content: space-between;

  transition: box-shadow 0.2s ease-in-out 0s;

  break-inside: avoid;
`;

const EventDiv3 = styled.div`
  height: 74px;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 400px) {
    display: flex;
    height: 32px;
    flex-direction: row;
  }
`

const EventLeft = styled.div`
  display: flex;

  -moz-box-align: center;

  align-items: center;

  flex: 1 1 auto;

  height: 100%;

  overflow: hidden;

  @media only screen and (max-width: 400px) {
    // -moz-box-align: center;
    //
    // align-items: center;
    //
    // -moz-box-pack: center;
    //
    // justify-content: center;
    padding-bottom: 10px;
  }
`;

const EventRight = styled.div`
  margin-left: 0.5em;

  display: flex;

  -moz-box-align: center;

  align-items: center;

  -moz-box-pack: end;

  justify-content: center;

  // overflow: hidden;
  //
  // flex: 0 0 200px;
`;

const EventPerson = styled.div`
  display: flex;

  -moz-box-align: center;

  align-items: center;

  -moz-box-pack: center;

  justify-content: center;

  color: rgba(51, 51, 51, 0.7);

  font-family: Lato, sans-serif;

  margin-right: 1em;
`;

const EventDate = styled.div`
  color: rgb(51, 51, 51);

  font-size: 12px;


  width: 10em;

  font-family: Lato, sans-serif;
`;

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
`;

const EventTitle = styled.div`
  color: rgb(51, 51, 51);

  font-size: 14px;

  line-height: 17px;

  overflow: hidden;

  white-space: nowrap;

  text-overflow: ellipsis;

  font-family: Lato, sans-serif;

  margin-top: .15em;

  align-self: center;
`;

const EventCheckbox = styled.div`
  width: 1.25em;
  height: 1.25em;
  border-radius: 4px;
`;

const EventContainer = styled.div`
  @media only screen and (min-width: 1100px) {
    overflow-y: auto;
    // TODO not sure how  to fix this yet, last instance get's 
    height: calc(100% - 5em);
  }

`;
const IconHoverDiv = styled.div`
  :hover {
    cursor: pointer;
  }
`;

const CalendarIcon = styled.div`
  transition: ease-in-out .2s;

  :hover {
    cursor: pointer;
    transform: scale(1.1);
  }
`;
const dateFormat = "ddd DD. MMM";

export function RightCalendar(props: {
  uri: string,
  calendar: any,
  months: any[],
  year: number,
  previousYear: number,
  nextYear: number,
}) {
  const [showDesc, setShowDesc] = React.useState();

  return (
    <div style={{ height: '100%' }}>
      {/*<a rel="noopener noreferrer" target={'_blank'} href={'https://munikum.no/app/calendar/' +props.uri}><h4 style={{textDecoration: 'underline', color: '#ff5c39'}}>Sjå årshjul i munikum</h4></a>*/}
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <h2 style={{ color: 'rgba(51,51,51,0.7)' }}>Aktivitetar</h2>
        <FlexDiv style={{ marginRight: '1em' }}>
          {/*<a className="switch-year-icons" style="all: unset; margin-right:.25em" href="{{previous_year_uri}}">*/}
          {/*  <*/}
          {/*</a>*/}
          <IconHoverDiv onClick={() => {
            myHistory.push('/s/' + props.uri + '?year=' + props.previousYear)
          }}>
            <FontAwesomeIcon icon={faLessThan} style={{ color: '#333', fontSize: '12px' }} />
          </IconHoverDiv>
          <h3 style={{ fontWeight: 'normal', margin: '0 .5em' }}>
            {props.year}
          </h3>
          <IconHoverDiv onClick={() => {
            myHistory.push('/s/' + props.uri + '?year=' + props.nextYear)
          }}>
            <FontAwesomeIcon icon={faGreaterThan} style={{ color: '#333', fontSize: '12px' }} />
          </IconHoverDiv>

          {/*<a className="switch-year-icons" style={{all: 'unset', marginLeft: '.25em'}} href="{{next_year_uri}}"> > </a>*/}
        </FlexDiv>
      </div>

      <EventContainer>
        {props.months.map((month) => {
          return <div key={month.name + month.year}>
            {/*{{~#if month.instances}}*/}
            <MonthDiv>{month.name} {month.year}</MonthDiv>
            {month.instances.map((instance: any, index: number) => {
              return <EventDiv key={instance.id}>
                <EventDiv2>
                  <EventDiv3>
                    <EventLeft onClick={() => {
                      if (instance.description) {
                        setShowDesc(showDesc === instance.id ? undefined : instance.id)
                      }
                    }}>
                      <div style={{ width: '1.25em', marginRight: '.5em' }}>
                        <EventCheckbox style={{ backgroundColor: props.calendar.color }} />
                      </div>
                      <EventTitle>
                        {instance.title} {instance.description &&
                          <FontAwesomeIcon icon={faSortDown} style={{
                            marginLeft: '.2em',
                            marginBottom: '.2em',
                            color: '333',
                            fontSize: '12px'
                          }} />}
                      </EventTitle>
                    </EventLeft>
                    <EventRight>
                      <EventPerson>
                        {instance.person_image ? <img alt={instance.person_name}
                                                      src={'https://hel1.your-objectstorage.com/munikum-public/' + instance.person_image}
                                                      style={{
                                                        width: '2em',
                                                        borderRadius: '50px'
                                                      }} /> : <Avatar
                          name={
                            instance.person_name
                          }
                        />}
                      </EventPerson>
                      <EventDate>
                        {instance.start_date === instance.end_date ?
                          <FlexDiv style={{ justifyContent: 'flex-start' }}>
                            <div style={{ width: '3.5em', fontWeight: 'bold' }}>Frist:</div>
                            {moment(instance.end_date).format(dateFormat)}
                          </FlexDiv> : <>
                            <FlexDiv style={{ justifyContent: 'flex-start' }}>
                              <div style={{ width: '3.5em', fontWeight: 'bold' }}>Start:
                              </div>
                              {moment(instance.start_date).format(dateFormat)}
                            </FlexDiv>
                            <FlexDiv style={{ justifyContent: 'flex-start' }}>
                              <div style={{ width: '3.5em', fontWeight: 'bold' }}>Frist:
                              </div>
                              {moment(instance.end_date).format(dateFormat)}
                            </FlexDiv>
                          </>}
                      </EventDate>
                      <div style={{
                        marginLeft: '.5em',
                        display: 'flex',
                        justifyContent: 'flex-end'
                      }}>
                        {/*eslint-disable-next-line*/}
                        <a rel={'noopener'} target={'_blank'}
                           style={{ display: 'flex', justifyContent: 'flex-end', color: '#333' }}
                           href={API_URL + '/meta/calendar-public?metaId=' + instance.id}>
                          <CalendarIcon>
                            <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '333' }} />
                          </CalendarIcon>
                        </a>
                      </div>
                    </EventRight>
                  </EventDiv3>
                  {showDesc === instance.id &&
                      <MarkdownPreview style={{ marginTop: '.25em', fontSize: '14px' }}
                                       description={instance?.description ?? ''} />
                  }
                </EventDiv2>
              </EventDiv>
            })}
          </div>;
        })}
      </EventContainer>

    </div>
  );
}
